import DataQuery from 'data/DataQuery';
import { Dashboard_Payments } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import { Dashboard_PaymentsCard } from 'features/shared/components/loaders/promiseLoadingAreas';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react';
import { useSelector } from 'react-redux';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import PaymentDTO from 'features/payments/dtos/PaymentDTO';
import DashboardSectionProps from 'features/dashboard/models/DashboardSectionProps';
import DashboardListingCard from '../components/DashboardListingCard';
import Payment from 'features/payments/components/Payment';
import PaymentHeader from 'features/payments/components/PaymentHeader';
import { useTranslation } from 'react-i18next';

const DashboardPaymentsSection = (props: DashboardSectionProps) => {
  // translations
  const t = useTranslation("dashboard\\dashboard").t;

  // private props
  const itemsCount = props.itemsCount ?? 4;

  // store
  const customer = (useSelector<IAppState, CustomerState>((store) => store.customer)).customer;

  // fetch data
  const query: DataQuery = {
    url: Dashboard_Payments,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: getQueryParams("Count", itemsCount.toString())
  };
  const { data, loadStatus } = useQuery<PaymentDTO[]>(query, [], [customer], {
    useTracker: true,
    area: Dashboard_PaymentsCard,
  });

  // render
  return (          
    <DashboardListingCard 
    title={t(`dashboardItems.${props.title}`)}
      items={data}
      renderItem={(item) => <Payment payment={item} />}
      itemsLoadStatus={loadStatus}
      moduleRoute="/payments"
      background={props.background}
      icon={props.icon}
      iconColor={props.iconColor}
      count={itemsCount}
      loaderArea={Dashboard_PaymentsCard}
      renderHeader={() => <PaymentHeader dashboardUsage />}
    />    
  )
}

export default DashboardPaymentsSection;
